<template>
	<div class="is-padded-left is-padded-right">
		<!-- title + subtitle-->
		<template v-if="currentStep < 4">
			<div class="columns is-hidden-desktop">
				<div class="column">
					<div class="button is-emv is-fullwidth is-padded" @click="scrollToOffers">
						<div class="is-flex-grow-2 has-text-left">
							<span class="icon">
								<i class="fa-solid fa-file-circle-check"></i>
							</span>
							<span> {{ translation.offer }} </span>
						</div>
						<span class="icon is-right"><i class="fa-solid fa-angle-right"></i></span>
					</div>
				</div>
			</div>
			<!-- bread crumb -->
			<bread-crumb :steps="steps" :current-step="currentStep" :next-step="goToOtherStep"></bread-crumb>
		</template>

		<div class="column is-full-mobile is-full-tablet is-padded-top is-full-desktop has-text-right">{{translation.required}}</div>

		<!-- Form step 1: Company info -->
		<form class="columns is-multiline is-mobile" @submit.prevent="goToNextStep">
			<template v-if="currentStep === 1">
				<div class="column is-full-mobile is-three-fifths-desktop is-three-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{translation.company}}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.company" v-model.trim="$v.formData.form.companyName.$model" @input="setFormValue('companyName', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.companyName.required && $v.formData.form.companyName.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-two-fifths-tablet is-two-fifths-desktop">
					<div class="field">
						<label class="label text-ellipse required">{{translation.vat}}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.vat" v-model="$v.formData.form.companyNumber.$model" @input="setFormValue('companyNumber', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.companyNumber.required && $v.formData.form.companyNumber.$dirty">{{ translation.validation.fieldRequired }}</div>
							<div class="error" v-if="!$v.formData.form.companyNumber.validVatNumber">{{ translation.validation.invalidVatNumber }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-three-fifths-desktop is-three-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{translation.legalForm}}</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select name="vat" v-model="$v.formData.form.legalForm.$model" @input="setFormValue('legalForm', $event.target.value)">
									<option value="" disabled selected>{{translation.makeSelection}}</option>
									<option v-for="type in legalForm" :value="type">{{ type }}</option>
								</select>
								<div class="error" v-if="!$v.formData.form.legalForm.required && $v.formData.form.legalForm.$dirty">{{ translation.validation.fieldRequired }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-two-fifths-desktop is-two-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{translation.vatSubject}}</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select name="vat" v-model="$v.formData.form.subjectToVat.$model" @input="setFormValue('subjectToVat', $event.target.value)">
									<option value="" disabled selected>{{translation.makeSelection}}</option>
									<option :value="true">Yes</option>
									<option :value="false">No</option>
								</select>
								<div class="error" v-if="!$v.formData.form.subjectToVat.required && $v.formData.form.subjectToVat.$dirty">{{ translation.validation.fieldRequired }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-three-fifths-desktop is-three-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{translation.street}}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.street" v-model="$v.formData.form.street.$model" @input="setFormValue('street', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.street.required && $v.formData.form.street.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-two-fifths-desktop is-two-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse">{{translation.box}}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.box" v-model="$v.formData.form.box.$model" @input="setFormValue('box', $event.target.value)">
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-one-fifths-desktop is-one-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{translation.zip}}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.zip" v-model="$v.formData.form.postalCode.$model" @input="setFormValue('postalCode', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.postalCode.required && $v.formData.form.postalCode.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-two-fifths-desktop is-two-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{translation.city}}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.city" v-model="$v.formData.form.city.$model" @input="setFormValue('city', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.city.required && $v.formData.form.city.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-two-fifths-desktop is-two-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{translation.country}}</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select name="vat" v-model="$v.formData.form.country.$model" @input="setFormValue('country', $event.target.value)">
									<option value="" disabled selected>{{translation.makeSelection}}</option>
									<option v-for="(value, key) in countries" :value="key">{{ value }}</option>
								</select>
								<div class="error" v-if="!$v.formData.form.country.required && $v.formData.form.country.$dirty">{{ translation.validation.fieldRequired }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="column is-hidden-mobile is-full-desktop"></div>
				<div class="column is-hidden-mobile"></div>
				<div class="column is-full-mobile is-narrow-tablet is-narrow-desktop">
					<button type="submit" class="button is-emv button-font is-fullwidth-mobile step-button">
						{{ translation.orderInfo}}
						<span class="icon icon-padding is-padded-right">
							<i class="fa-solid fa-arrow-right"></i>
						</span>
					</button>
				</div>
			</template>
		</form>

		<!-- Form step 2: Order info -->
		<form class="columns is-multiline is-mobile" method="post" @submit.prevent="goToNextStep">
			<template v-if="currentStep === 2">
				<div class="column is-full-mobile is-6-desktop is-6-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{ translation.startDate }}</label>
						<div class="control">
							<input class="input" type="date" :placeholder="translation.startDate" v-model="$v.formData.form.contract.$model" @input="setFormValue('contract', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.contract.required && $v.formData.form.contract.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-6-desktop is-6-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{ translation.socialSecretariat }}</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select name="socsec" v-model="$v.formData.form.socsec.$model" @input="setFormValue('socsec', $event.target.value)">
									<option value="" disabled selected>{{translation.makeSelection}}</option>
									<option :value="0">no social secretariat</option>
									<option v-for="(type, key) in socialSecretariat" :value="key">{{ type }}</option>
								</select>
								<div class="error" v-if="!$v.formData.form.socsec.required && $v.formData.form.socsec.$dirty">{{ translation.validation.fieldRequired }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-three-fifths-desktop is-three-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{ translation.placer }}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.placer" v-model="$v.formData.form.order.$model" @input="setFormValue('order', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.order.required && $v.formData.form.order.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-two-fifths-desktop is-two-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{ translation.pay }}</label>
						<div class="control">
							<div class="select is-fullwidth">
								<select name="payBy" v-model="$v.formData.form.payBy.$model" @input="setFormValue('payBy', $event.target.value)">
									<option value="" disabled selected>{{translation.makeSelection}}</option>
									<option v-for="(type,key) in paymentMethod" :value="key">{{ translation.payment_method[key] }}</option>
								</select>
								<div class="error" v-if="!$v.formData.form.payBy.required && $v.formData.form.payBy.$dirty">{{ translation.validation.fieldRequired }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="column is-half-desktop is-full-mobile p-0">
					<div class="column is-full-mobile is-narrow-tablet is-narrow-desktop">
						<button @click="goToOtherStep(currentStep - 1)" class="button button-font is-fullwidth-mobile step-button">
						<span class="icon icon-padding is-padded-left pr-5">
							<i class="fa-solid fa-arrow-left"></i>
						</span>
							{{ translation.previous }}
						</button>
					</div>
				</div>
				<div class="column is-half-desktop is-full-mobile p-0 has-text-right">
					<div class="column is-full-mobile is-narrow-tablet is-narrow-desktop">
						<button type="submit" class="button is-emv button-font is-fullwidth-mobile step-button">
							{{ translation.myInfo }}
							<span class="icon icon-padding is-padded-right">
								<i class="fa-solid fa-arrow-right"></i>
							</span>
						</button>
					</div>
				</div>
			</template>
		</form>

		<!-- Form step 3: Your info -->
		<form class="columns is-multiline is-mobile" method="post" @submit.prevent="goToNextStep">
			<template v-if="currentStep === 3">
				<div class="column is-full-mobile is-two-fifths-desktop is-two-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{ translation.firstname }}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.firstname" v-model="$v.formData.form.firstname.$model" @input="setFormValue('firstname', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.firstname.required && $v.formData.form.firstname.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-three-fifths-desktop is-three-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{ translation.lastname }}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.lastname" v-model="$v.formData.form.lastname.$model" @input="setFormValue('lastname', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.lastname.required && $v.formData.form.lastname.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-three-fifths-desktop is-three-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{ translation.email }}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.email" v-model="$v.formData.form.email.$model" @input="setFormValue('email', $event.target.value)">
							<div class="error" v-if="!$v.formData.form.email.required && $v.formData.form.email.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-two-fifths-desktop is-two-fifths-tablet">
					<div class="field">
						<label class="label text-ellipse required">{{ translation.phone }}</label>
						<div class="control">
							<input class="input" type="text" :placeholder="translation.phone" v-model="$v.formData.form.phone.$model" @input="setFormValue('phone', $event.target.value)" autocomplete="disabled">
							<div class="error" v-if="!$v.formData.form.phone.required && $v.formData.form.phone.$dirty">{{ translation.validation.fieldRequired }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full">
					<div class="has-text-left">
						<p class="is-marged-top has-text-weight-bold">
							{{ translation.passwordContain }}
						</p>
						<div class="content is-marged-top is-marged-bottom">
							<p>
								<span class="icon is-marged-right">
									<i class="fa-solid fa-solid" :class="hasMin8char ? 'fa-circle-check' : 'fa-thin fa-circle'"></i>
								</span>
								<span>
									{{ translation.passwordCharacters }}
								</span>
							</p>
							<p>
								<span class="icon is-marged-right">
									<i class="fa-solid fa-solid" :class="hasSpecialCharacter ? 'fa-circle-check' : 'fa-thin fa-circle'"></i>
								</span>
								<span>
									{{ translation.passwordSpecial }}
								</span>
							</p>
							<p>
								<span class="icon is-marged-right">
									<i class="fa-solid fa-solid" :class="hasNumber ? 'fa-circle-check' : 'fa-thin fa-circle'"></i>
								</span>
								<span>
									{{ translation.passwordNumber }}
								</span>
							</p>
							<p>
								<span class="icon is-marged-right">
									<i class="fa-solid fa-solid" :class="hasLetter ? 'fa-circle-check' : 'fa-thin fa-circle'"></i>
								</span>
								<span>
									{{ translation.passwordLetter }}
								</span>
							</p>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-half-desktop is-half-tablet">
					<div class="field">
						<div class="control has-icons-right">
							<label class="label text-ellipse required" for="pwd_password-confirm">
								{{ translation.password }}
							</label>
							<input
								class="input"
								:type="passwordtype ? 'password' : 'text'"
								id="pwd_password"
								name="new_password"
								v-model="$v.formData.form.password.$model"
								@input="setFormValue('password', $event.target.value)"
								:placeholder="translation.password"
								autocomplete="disabled"
							/>
							<span class="icon is-small is-right is-clickable password-display" @click="changePasswordType">
								<i class="fa-solid" :class="passwordtype ? 'fa-eye' : 'fa-eye-slash'"></i>
							</span>
							<div class="error text-ellipse" v-if="!$v.formData.form.password.required && $v.formData.form.password.$dirty">{{ translation.validation.fieldRequired }}</div>
							<div class="error text-ellipse" v-else-if="!$v.formData.form.password.minLength && $v.formData.form.password.$dirty">{{ translation.validation.passwordMinLength }}</div>
							<div class="error text-ellipse" v-else-if="hasPasswordErrors">{{ translation.validation[hasPasswordErrors] }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full-mobile is-half-desktop is-half-tablet">
					<div class="field">
						<div class="control has-icons-right">
							<label class="label text-ellipse required" for="pwd_password-confirm">
								{{ translation.confirmPassword }}
							</label>
							<input
								class="input"
								:type="passwordconfirmtype? 'password' : 'text'"
								id="pwd_password-confirm"
								name="new_password_confirmation"
								v-model="$v.formData.form.confirmPassword.$model"
								@input="setFormValue('confirmPassword', $event.target.value)"
								:placeholder="translation.confirmPassword"
								autocomplete="disabled"
							/>
							<span class="icon is-small is-right is-clickable password-display" @click="changeConfirmPasswordType">
								<i class="fa-solid" :class="passwordconfirmtype ? 'fa-eye' : 'fa-eye-slash'"></i>
							</span>
							<div class="error text-ellipse" v-if="!$v.formData.form.confirmPassword.required && $v.formData.form.confirmPassword.$dirty">{{ translation.validation.fieldRequired }}</div>
							<div class="error text-ellipse" v-if="!$v.formData.form.confirmPassword.minLength && $v.formData.form.confirmPassword.$dirty">{{ translation.validation.passwordMinLength }}</div>
						</div>
					</div>
				</div>
				<div class="column is-full checkbox-container">
					<label class="checkbox">
						<input type="checkbox" v-model="$v.formData.form.acceptCgu.$model" @input="setFormValue('acceptCgu', !formData.form.acceptCgu)">
						{{translation.cgvApprove1}}
						<a :href="translation.cgvLink" target="_blank">{{translation.cgvApprove2}}</a>
					</label>
					<div class="error" v-if="!formData.form.acceptCgu && $v.formData.form.acceptCgu.$dirty">{{ translation.validation.mustAccept }}</div>
				</div>
				<div class="column is-full error" v-if="formError">{{ formError }}</div>
				<div class="column is-half-desktop is-full-mobile p-0">
					<div class="column is-full-mobile is-narrow-tablet is-narrow-desktop">
						<button @click="goToOtherStep(currentStep - 1)" class="button button-font is-fullwidth-mobile step-button">
						<span class="icon icon-padding is-padded-left pr-5">
							<i class="fa-solid fa-arrow-left"></i>
						</span>
							{{ translation.previous }}
						</button>
					</div>
				</div>
				<div class="column is-half-desktop is-full-mobile p-0 has-text-right">
					<div class="column is-full-mobile is-narrow-tablet is-narrow-desktop">
						<button type="submit" class="button is-emv button-font is-fullwidth-mobile step-button">
							{{ translation.submit }}
							<span class="icon icon-padding is-padded-right">
								<i class="fa-solid fa-arrow-right"></i>
							</span>
						</button>
					</div>
				</div>
			</template>
		</form>
	</div>
</template>

<script>
import { required, minLength, sameAs, helpers } from 'vuelidate/lib/validators';
import BreadCrumb from "./breadCrumb.vue";
import Password from "../password.vue";

const vatNumberRegex = {
	'BE': /^(BE)?0[0-9]{9}$/,
	'LU': /^(LU)?[0-9]{8}$/,
	'NL': /^(NL)?[0-9]{9}B[0-9]{2}$/,
	'DE': /^(DE)?[0-9]{9}$/,
	'FR': /^(FR)?[0-9A-Z]{2}[0-9]{9}$/
};
const validVatNumber = (value) => {
	let firstPart = value.slice(0, 2);
	let country = firstPart.replace(/[^a-zA-Z]/g, '').length === 2 ? firstPart : 'BE';

	return !helpers.req(value) || vatNumberRegex[country].test(value);
};

export default {
	components: {Password, BreadCrumb},
	data: function()
	{
		let breadcrumb = [];
		let i = 1;
		for (let key in this.$props.translation.breadcrumb)
		{
			breadcrumb.push({id : i, title : this.$props.translation.breadcrumb[key]});
			i++;
		}

		let form = this.formInfo;

		return {
			steps : breadcrumb,
			formData : {
				form : form,
				isLoading : false
			},
			passwordtype : true,
			passwordconfirmtype : true,
			passwordSpecialError : false,
			formError : ''
		}
	},
	validations: {
		formData: {
			form: {
				companyName: {
					required,
				},
				companyNumber: {
					required,
					validVatNumber
				},
				legalForm: {
					required,
				},
				subjectToVat: {
					required,
				},
				street: {
					required,
				},
				number: {
					required,
				},
				box: {},
				postalCode: {
					required,
				},
				city: {
					required,
				},
				country: {
					required,
				},
				contract: {
					required,
				},
				socsec: {
					required,
				},
				order: {
					required,
				},
				payBy: {
					required,
				},
				firstname: {
					required,
				},
				lastname: {
					required,
				},
				email: {
					required,
				},
				phone: {
					required,
				},
				password: {
					required,
					minLength: minLength(8)
				},
				confirmPassword: {
					required,
					minLength: minLength(8)
				},
				acceptCgu: {
					required,
					sameAs: sameAs( () => true )
				},
				validationGroup: {
					1: [
						'formData.form.companyName',
						'formData.form.companyNumber',
						'formData.form.legalForm',
						'formData.form.subjectToVat',
						'formData.form.street',
						'formData.form.box',
						'formData.form.postalCode',
						'formData.form.city',
						'formData.form.country',
					],
					2: [
						'formData.form.contract',
						'formData.form.socsec',
						'formData.form.order',
						'formData.form.payBy',
					],
					3: [
						'formData.form.firstname',
						'formData.form.lastname',
						'formData.form.email',
						'formData.form.phone',
						'formData.form.password',
						'formData.form.confirmPassword',
						'formData.form.acceptCgu',
					],
				},
			},
		},
	},
	props: {
		translation : {
			type: Object,
			required: true,
		},
		nextStep : {
			type : Function,
			required : true,
		},
		otherStep: {
			type : Function,
			required : true,
		},
		scrollToOffers: {
			type : Function,
			required : true,
		},
		currentStep : {
			type : Number,
			require : true,
		},
		url : {
			type : String,
			require : true,
		},
		legalForm : {
			type : Object,
			require : true
		},
		socialSecretariat : {
			type : Object,
			require : true
		},
		paymentMethod : {
			type : Object,
			require : true
		},
		formInfo : {
			type : Object,
			require : true
		},
		countries : {
			type : Object,
			require : true
		}
	},
	methods: {
		submitForm : function()
		{
			let self = this;

			if(this.formData.form.socsec === 0)
			{
				this.formData.form.socsec = null;
			}
			(new ApiMonizze())
				.postDataFromApi(
					this.url,
					this.formData.form,
					() => {this.nextStep();}
				)
				.catch(function (error)
				{
					self.formError = error.response.data.message;
				}
			);
		},
		changePasswordType : function(e)
		{
			this.passwordtype = !this.passwordtype;
		},
		changeConfirmPasswordType : function()
		{
			this.passwordconfirmtype = !this.passwordconfirmtype;
		},
		setFormValue : function (field, value)
		{
			this.formData.form[field] = value;
			this.$v.formData.form[field].$touch();
		},
		goToNextStep : function ()
		{
			if(this.validateCurrentForm())
			{
				if (this.currentStep === 3)
				{
					this.submitForm();
				} else {
					this.nextStep();
				}
			}
		},
		goToOtherStep : function (step)
		{
			if(this.currentStep > step || this.validateCurrentForm())
			{
				this.otherStep(step);
			}
		},
		incorrectPassword : function ()
		{
			let hasSpecialCharacter = /\W/g;
			let hasNumber = /\d+/;
			let hasLetter = /[a-zA-Z]+/;

			if (!hasSpecialCharacter.test(this.formData.form.password))
			{
				return 'noSpecialCharacterPassword';
			}
			else if (!hasNumber.test(this.formData.form.password))
			{
				return 'noNumberPassword';
			}
			else if (!hasLetter.test(this.formData.form.password))
			{
				return 'noLetterPassword';
			}
			else if (this.formData.form.password !== this.formData.form.confirmPassword)
			{
				return 'notSamePassword';
			}
			else
			{
				return false;
			}
		},
		validateCurrentForm: function ()
		{
			let validationCurrentForm = this.$v.formData.form.validationGroup[this.currentStep];

			if (validationCurrentForm.$invalid)
			{
				Object.keys(validationCurrentForm.$params).forEach((key) => {
					let lastKey = key.split('.').slice(-1)[0];
					this.$v.formData.form[lastKey].$touch()
				});
				return false;
			}

			if (this.currentStep === 3 && this.incorrectPassword())
			{
				return false;
			}

			return true;
		}
	},
	computed: {
		hasSpecialCharacter : function(){
			let specialCharacters = /\W/g;
			return specialCharacters.test(this.formData.form.password);
		},
		hasNumber : function(){
			let numbers = /\d+/;
			return numbers.test(this.formData.form.password);
		},
		hasLetter : function(){
			let letters = /[a-zA-Z]+/;
			return letters.test(this.formData.form.password);
		},
		hasMin8char : function()
		{
			return this.formData.form.password.length >= 8;
		},
		hasPasswordErrors : function()
		{
			return this.incorrectPassword();
		}
	}
}
</script>

<style lang="sass" scoped>
	.step-button
		padding: 12px 24px
		border-radius: 2px
		height: 90%
	.icon-padding
		padding-left: 24px
	.input
		box-shadow: none
		max-width: 100%
		width: 100%
	.select:not(.is-multiple)
		height: 3.25em
	label.required::after
		content: '*'
		color: #E60030
		margin-left: 5px
	.icon .fa-circle-check
		color: #14CC4D
	.icon .fa-circle
		color: #E60030
	.password-display
		height: 3em !important
		top: 29px !important
	.control,
	.checkbox-container
		padding-bottom: 20px
		position: relative
	.control .error,
	.checkbox-container .error
		position: absolute
		bottom: 0
	.control .select .error
		bottom: -20px
</style>
